import axios from 'axios'
import { api } from '../api'

/**
 * Constants
 * */
export const moduleName = 'checkclient'

export const START = '_START'
export const SUCCESS = '_SUCCESS'
export const ERROR = '_ERROR'

export const CHECK_CLIENT = `${moduleName}/CHECK_CLIENT`
export const CLEAR_CHECK = `${moduleName}/CLEAR_CHECK`
export const RESET = `${moduleName}/RESET`

/**
 * Reducer
 * */
const defaultState = {
    loading: false,
	checked: false,
    check: null,
    error: null
}

export default (state = defaultState, action) => {
    const { type, check, error, payload } = action

    switch (type) {
        case CHECK_CLIENT + START:
            return { 
                ...state, 
                loading: true
            }

        case CHECK_CLIENT + SUCCESS:
            return {
                ...state,
                loading: false,
                checked: true,
                check
            }

        case CHECK_CLIENT + ERROR:
            return {
                ...state,
                loading: false,
                checked: true,
                check,
                error
            }

        case CLEAR_CHECK:
            return {
                ...state,
                loading: false,
                checked: false,
                check: null,
                error: null
            }

        case RESET: 
            return defaultState

        default:
			return state
	}
}

/**
 * Action Creators
 * */

export const checkClient = (params) => async (dispatch) => {

	dispatch({ type: CHECK_CLIENT + START })

	try {
		const { data } = await axios.post(api + '?' + new URLSearchParams(params).toString())
		console.log(data);

		if (data.success) {
			dispatch({
				type: CHECK_CLIENT + SUCCESS,
				check: data.content
			});
			
		}
		if(data.error) {
			dispatch({
				type: CHECK_CLIENT + ERROR,
                check: !data.error,
				error: data.message
			});			
		}
	} catch (error) {
		console.log(error)
		if (error.response)
			dispatch({
				type: CHECK_CLIENT + ERROR
			});
	}	
}


export const checkingClient = () => async (dispatch) => dispatch({ type: CHECK_CLIENT + SUCCESS, check: true })

export const clearCheck = () => async (dispatch) => dispatch({ type: CLEAR_CHECK })

export const resetCheckStore = () => async (dispatch) => dispatch({ type: RESET })
